import PropTypes from 'prop-types';
import { FREQUENCIES, FREQUENCY_ORIGINS } from './consts';

const frequencyValues = [...Object.values(FREQUENCIES), null];

export const aggregatedSettingsType = PropTypes.objectOf(
  PropTypes.shape({
    value: PropTypes.oneOf(frequencyValues).isRequired,
    name: PropTypes.string.isRequired,
    origin: PropTypes.oneOf(Object.values(FREQUENCY_ORIGINS)).isRequired
  })
);

export const aggregatedOptionsType = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string));
